import React, { Fragment } from 'react';

const Input = ({ label, ...rest }) => {
    return (
        <Fragment>
            <label>{label}</label>
            <input style={input} {...rest} />
        </Fragment>
    );
};

const input = {
    borderRadius: 0,
    fontSize: '12px',
};

export default Input;